import React, { useState } from "react";
import Image from "../../components/Image/Image";
import ImageModal from "../../components/ImageModal/ImageModal";
import house from "../../assets/images/1.webp";
import garden from "../../assets/images/3.webp";
import wall from "../../assets/images/4.webp";
import stairs from "../../assets/images/5.webp";
import ButtonLink from "../../components/ButtonLink/ButtonLink";
import Layout from "../../components/Layout/Layout";
import * as S from "./Styles";

const About = () => {
  const [modalImage, setModalImage] = useState<{ src: string; alt: string } | null>(null);

  const openModal = (src: string, alt: string) => {
    setModalImage({ src, alt });
  };

  const closeModal = () => {
    setModalImage(null);
  };

  return (
    <Layout
      title="Tømrer og snekker i Vestby | Grønvold Byggservice - Pålitelig og erfaren partner"
      description="Grønvold Byggservice tilbyr skreddersydde tømrer- og snekkertjenester i Vestby. Lang erfaring, høy kvalitet og god kundedialog - kontakt oss for gratis befaring.">
      <S.Container>
        <S.PageTitle>Om Grønvold Byggservice AS</S.PageTitle>
        <S.ContainerOne>
          <S.TextContainer>
            <S.StyledTextContent>
              Grønvold Byggservice har base i Vestby og er din pålitelige samarbeidspartner for alle snekker- og
              tømrerbehov. Vi har lang erfaring og sammen med solid kompetanse tilbyr vi våre kunder løsninger tilpasset
              individuelle ønsker. Om vi skal hjelpe med å finne nye løsninger eller rette opp gamle feil, så er
              kvalitet alltid viktigst. Vi tar på oss både små og store oppdrag innen renovering eller ombygging av
              eldre og nye bygg, og vi er alltid klare til å bidra med vår ekspertise.
            </S.StyledTextContent>
            <S.StyledTextContent>
              Hos Grønvold Byggservice leter vi etter de beste løsningene i samarbeid med deg som kunde. Vi forstår at
              hver kunde har unike behov, og et samarbeid med oss er et samarbeid du kan stole på.
            </S.StyledTextContent>
          </S.TextContainer>
          <S.ImageContainer>
            <Image
              src={house}
              alt="Platting"
              width={"100%"}
              height={"auto"}
              useRadius
              useShadow
              clickable
              onClick={() => openModal(house, "Platting")}
            />
          </S.ImageContainer>
        </S.ContainerOne>
        <S.ContainerTwo>
          <S.ImageContainer>
            <Image
              src={garden}
              alt="Platting i hage"
              width={"100%"}
              height={"auto"}
              useRadius
              useShadow
              clickable
              onClick={() => openModal(garden, "Platting i hage")}
            />
          </S.ImageContainer>
          <S.TextContainer>
            <S.StyledTextContent>
              I Grønvold byggservice skal vi alltid være stolte av arbeidet vi leverer. Vi følger alltid opp etter endt
              arbeid og når du er fornøyd er vi fornøyde. Vi setter søkelys på å bygge i nært samarbeid med våre kunder
              gjennom åpen dialog og grundig oppfølging underveis, slik at du alltid vet hva du kan forvente.
            </S.StyledTextContent>
            <S.StyledTextContent>
              Du kan være sikker på at jobben utført av oss lever opp til de høyeste standardene, og vi streber etter å
              overgå dine forventninger. Velg Grønvold Byggservice for et solid håndverk og en god kundeopplevelse. Ta
              kontakt på telefon eller mail for en uforpliktende og gratis befaring.
            </S.StyledTextContent>
            <S.StyledContactContent>
              E-post: <ButtonLink href="mailto:agronvold@outlook.com">agronvold@outlook.com</ButtonLink>
            </S.StyledContactContent>
            <S.StyledContactContent>
              Telefon: <ButtonLink href="tel:+47-46905066">46905066</ButtonLink>
            </S.StyledContactContent>
            <S.StyledContactContent>
              <ButtonLink arrowIcon href="/kontakt#contact-form">
                Kontaktskjema
              </ButtonLink>
            </S.StyledContactContent>
          </S.TextContainer>
        </S.ContainerTwo>
        <S.CollidedImageContainer>
          <S.ImageContainer>
            <Image
              src={wall}
              alt="Skillevegg med dør"
              width={"100%"}
              height={"auto"}
              useRadius
              useShadow
              clickable
              onClick={() => openModal(wall, "Skillevegg med dør")}
            />
          </S.ImageContainer>
          <S.ImageContainer className="rightImage">
            <Image
              src={stairs}
              alt="Inngangsparti"
              width={"100%"}
              height={"auto"}
              useRadius
              useShadow
              clickable
              onClick={() => openModal(stairs, "Inngangsparti")}
            />
          </S.ImageContainer>
        </S.CollidedImageContainer>
      </S.Container>

      <ImageModal src={modalImage?.src || ""} alt={modalImage?.alt || ""} isOpen={!!modalImage} onClose={closeModal} />
    </Layout>
  );
};

export default About;
